export default function Tab({ children }) {
  return <section>{children}</section>
}
